import { render, staticRenderFns } from "./NewsTile.vue?vue&type=template&id=3ec216db&scoped=true"
import script from "./NewsTile.vue?vue&type=script&lang=js"
export * from "./NewsTile.vue?vue&type=script&lang=js"
import style0 from "./NewsTile.vue?vue&type=style&index=0&id=3ec216db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec216db",
  null
  
)

export default component.exports